import { useState } from 'react';
import classNames from 'classnames';
import Image from 'next/image';
import i18n from '@/settings/i18n';
import {
  formatGoodReviewsPercentage,
  formatOrigin,
} from '@/components/v2/product/hooks/helpers';
import { useProductPageContext } from '@/components/v2/product/hooks/useProductPageContext';
import SellerModal from './seller/SellerModal';
import { resolveGoodReviewsPercentage } from './seller/helpers';
import settings from '@/settings';

const t = i18n.init('product');

const Origin = () => {
  const {
    selectedOffer,
    vendorDetails,
    isFetchingSku,
    selectedSkuDetails: { condition },
  } = useProductPageContext();
  const [showModal, setShowModal] = useState(false);

  const vendorCountry = selectedOffer?.location?.country;

  const isLocalVendor =
    vendorCountry?.toUpperCase() === settings.country_code?.toUpperCase();

  const formattedOrigin = formatOrigin(isLocalVendor);

  const vendorName = selectedOffer?.vendor.name ?? '';

  const isBrandNew = condition === 'Brand New';

  const positiveFeedback = formatGoodReviewsPercentage(
    resolveGoodReviewsPercentage(
      vendorDetails.reviewsCount,
      vendorDetails.goodReviewsPercentage,
    ),
  );

  return (
    <>
      {vendorName && (
        <>
          <div
            className={classNames('text-xs text-gray-700', {
              'opacity-60': isFetchingSku,
            })}
          >
            {isBrandNew ? (
              <span>{t`Shipped by`} </span>
            ) : (
              <span>
                {t`Professionally refurbished`}{' '}
                {/* Only English is long enough to need trimming on mobile */}
                <span
                  className={classNames(
                    i18n.getLocale() === 'en' && 'hidden sm:inline',
                  )}
                >
                  {t`and shipped`}
                </span>{' '}
                {t`by`}{' '}
              </span>
            )}

            <button
              className="inline focus:outline-none"
              onClick={() => {
                setShowModal(true);
              }}
            >
              {formattedOrigin.flag && (
                <Image
                  alt=""
                  src={formattedOrigin.flag}
                  height={12}
                  width={18}
                  className="-mt-1 mr-1 inline-block h-4 w-auto"
                />
              )}
              <span className="font-bold">{vendorName}</span>
              {positiveFeedback && (
                <>
                  {' '}
                  <span className="underline">
                    {t`${{ percentage: positiveFeedback }}% positive`}
                  </span>
                </>
              )}
            </button>
          </div>
        </>
      )}

      <SellerModal setShowModal={setShowModal} showModal={showModal} />
    </>
  );
};

export default Origin;
